// The "When" card title on a call landing page.
//
// CC's cadence phrase is generated from the recurrence rule, so a short series
// with a fixed end (TSB Live Nov–Dec 2026: 19 Nov and 17 Dec) reads "Third
// Thursday of the month" — true, but not how a member thinks about it. When the
// series has an end date and its remaining dates fit on one line, list them.
// Open-ended series keep CC's cadence phrase (the hero and the card body show
// the next date).

export interface UpcomingDate { start_utc: string; timezone: string }

const MAX_LISTED = 4;

export function formatDayLong(startUtc: string, timezone: string): string {
  return new Intl.DateTimeFormat('en-US', {
    timeZone: timezone || 'America/Toronto', weekday: 'long', month: 'long', day: 'numeric',
  }).format(new Date(startUtc));
}

function joinList(items: string[]): string {
  if (items.length <= 1) return items[0] ?? '';
  if (items.length === 2) return `${items[0]} and ${items[1]}`;
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`;
}

export function callWhenTitle(
  cadence: string | null,
  seriesEndDate: string | null | undefined,
  upcoming: UpcomingDate[] | null | undefined,
): string {
  const dates = upcoming ?? [];
  if (seriesEndDate && dates.length > 0 && dates.length <= MAX_LISTED) {
    return joinList(dates.map((d) => formatDayLong(d.start_utc, d.timezone)));
  }
  if (cadence) return cadence.charAt(0).toUpperCase() + cadence.slice(1);
  return 'Recurring';
}
